<script>
  import Inview from 'svelte-inview';

  import InteractiveBarChart from './interactiveBarChart.svelte';
  import InteractiveLineChart from './interactiveLineChart.svelte';
  import BumpChart from './bumpChart.svelte';

  export let chart;
  export let figcap;
  let ref;

  let totalInviewDuration = 0,
    lastInviewTime = null;

  function startInview() {
    lastInviewTime = performance.now();
  }

  function endInview() {
    const inviewDuration = performance.now() - lastInviewTime;
    totalInviewDuration += inviewDuration;
    if (inviewDuration > 3000) {
      // console.log(chart, "inview", inviewDuration, totalInviewDuration);
      const event = 'inview';
      dataLayer.push({ event, chart, inviewDuration });
    }
  }

  let totalInteractDuration = 0,
    lastInteractTime = null;

  function startInteract() {
    lastInteractTime = performance.now();
  }

  function endInteract() {
    const interactDuration = performance.now() - lastInteractTime;
    totalInteractDuration += interactDuration;
    if (interactDuration > 1000) {
      // console.log(chart, "interact", interactDuration, totalInteractDuration);
      const event = 'interact';
      dataLayer.push({ event, chart, interactDuration });
    }
  }
</script>

<style lang="scss">
  figure {
    margin: 2rem 0;
  }

  figcaption {
    text-align: center;
    margin-top: 0.5rem;
  }

  a {
    text-decoration: none;
    color: var(--cl-ippd);

    &:hover {
      border-bottom: 1px dotted var(--cl-ippd);
    }
  }
</style>

<Inview let:inView wrapper={ref} on:enter={startInview} on:leave={endInview}>
  <figure
    bind:this={ref}
    on:mouseenter={startInteract}
    on:mouseleave={endInteract}>
    {#if chart === 'BumpChart'}
      <BumpChart />
    {:else if chart === 'InteractiveLineChart'}
      <InteractiveLineChart />
    {:else if chart === 'InteractiveBarChart'}
      <InteractiveBarChart />
    {/if}
    <figcaption>
      {@html figcap}
      <br />
      <a href="#methodology">ข้อมูลและระเบียบวิธีวิจัย</a>
    </figcaption>
  </figure>
</Inview>
